import { useState } from 'react';
import { Link } from 'react-router-dom';
import { WhitepaperForm } from '../forms/WhitepaperForm';

export const Footer = () => {
  const [showWhitepaperForm, setShowWhitepaperForm] = useState(false);

  return (
    <>
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="Safe Standard" className="h-10 w-auto" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Governance architecture for AI-mediated safeguarding. Beginning with child protection.
            </p>
            <a
              href="https://linkedin.com/company/safestandard/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mt-4"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              <span className="text-sm">Follow on LinkedIn</span>
            </a>
          </div>

          {/* Architecture */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-6 text-slate-300">
              Architecture
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/governance" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Governance Layer
                </Link>
              </li>
              <li>
                <Link to="/labs" className="text-slate-400 hover:text-white transition-colors text-sm">
                  SAFE Labs
                </Link>
              </li>
              <li>
                <Link to="/safescore" className="text-slate-400 hover:text-white transition-colors text-sm">
                  SAFEScore
                </Link>
              </li>
              <li>
                <Link to="/sail" className="text-slate-400 hover:text-white transition-colors text-sm">
                  SAIL SDK
                </Link>
              </li>
            </ul>
          </div>

          {/* Ecosystem */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-6 text-slate-300">
              Ecosystem
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/network" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Global Authority
                </Link>
              </li>
              <li>
                <Link to="/council" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Governance Council
                </Link>
              </li>
              <li>
                <Link to="/roadmap" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Adoption Pathway
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-6 text-slate-300">
              Resources
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/why-safe" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Why SAFE Exists
                </Link>
              </li>
              <li>
                <Link to="/brand" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Brand & Media Resources
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Press & Media
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => setShowWhitepaperForm(true)}
                  className="text-slate-400 hover:text-white transition-colors text-sm text-left"
                  data-testid="footer-whitepaper-btn"
                >
                  Governance Whitepaper
                </button>
              </li>
              <li>
                <span className="text-slate-500 text-sm">Documentation (Coming Soon)</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} SAFE Governance Architecture. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/brand" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
                Brand Guidelines
              </Link>
              <Link to="/press" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">
                Media
              </Link>
              <a href="https://linkedin.com/company/safestandard/" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-slate-300 transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Final tagline */}
      <div className="bg-slate-950 py-6 pb-20 md:pb-6">
        <p className="text-center text-slate-500 text-sm italic px-6">
          "The harm was never in the content. It was in the relationship. We built the alternative."
        </p>
      </div>
    </footer>

    <WhitepaperForm
      isOpen={showWhitepaperForm}
      onClose={() => setShowWhitepaperForm(false)}
    />
    </>
  );
};
